import { useEditorState } from '@tiptap/react';
import { useCallback } from 'react';
import { isCustomNodeSelected, isTextSelected } from '../utils';

const useTextMenuStates = (editor) => {
  const states = useEditorState({
    editor,
    selector: (ctx) => ({
      isBold: ctx.editor.isActive('bold'),
      isItalic: ctx.editor.isActive('italic'),
      isStrike: ctx.editor.isActive('strike'),
      isUnderline: ctx.editor.isActive('underline'),
      isCode: ctx.editor.isActive('code'),
      isAlignLeft: ctx.editor.isActive({ textAlign: 'left' }),
      isAlignCenter: ctx.editor.isActive({ textAlign: 'center' }),
      isAlignRight: ctx.editor.isActive({ textAlign: 'right' }),
      isAlignJustify: ctx.editor.isActive({ textAlign: 'justify' }),
      currentColor: ctx.editor.getAttributes('textStyle')?.color || undefined,
      currentHighlight: ctx.editor.getAttributes('highlight')?.color || undefined,
      currentFont: ctx.editor.getAttributes('textStyle')?.fontFamily || undefined,
      currentSize: ctx.editor.getAttributes('textStyle')?.fontSize || undefined,
    }),
  });

  const shouldShow = useCallback(
    ({ view, from }) => {
      if (!view || editor.view.dragging) {
        return false;
      }

      const domAtPos = view.domAtPos(from || 0).node;
      const nodeDOM = view.nodeDOM(from || 0);
      const node = nodeDOM || domAtPos;

      if (isCustomNodeSelected(editor, node)) {
        return false;
      }

      return isTextSelected({ editor });
    },
    [editor],
  );

  return {
    shouldShow,
    ...states,
  };
};

export default useTextMenuStates;
